import { Component, DestroyRef, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AccessOptions } from '@shared/models/accessOptions.model';
import { Formation } from '@shared/models/formation.model';
import { FormationsGroups } from '@shared/models/formationsGroups.model';
import { HospitalNames } from '@shared/models/hospitalTypes.model';
import { FormatSeniorityPipe } from '@shared/pipes/format-seniority.pipe';
import { SubscriptionManager } from '@shared/services/subscription-manager.service';
import { ANESTHETIST, CYCLEDURATIONS, NOT_NURSES, NURSE_TYPES } from 'src/app/shared/const/globals.const';
import { cycle } from 'src/app/shared/models/cycle.model';
import { CycleTVO } from 'src/app/shared/models/cycleTVO.model';
import { Exclusion } from 'src/app/shared/models/exclusion.model';
import { Profile } from 'src/app/shared/models/profile.model';
import { CycleService } from 'src/app/shared/services/cycle.service';
import { CycleTVOService } from 'src/app/shared/services/cycleTVO.service';
import { ErrorService } from 'src/app/shared/services/error.service';
import { ExclusionService } from 'src/app/shared/services/exclusion.service';
import { NightNeedsListService } from 'src/app/shared/services/nightNeedsList.service';
import { ProfileService } from 'src/app/shared/services/profile.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import { UserService } from 'src/app/shared/services/user.service';
import { InstanceIdService } from '@shared/services/instance-id.service';

@Component({
  selector: 'app-create-cycle-dialog',
  templateUrl: './create-cycle-dialog.component.html',
  styleUrls: ['./create-cycle-dialog.component.scss'],
  standalone: false,
})
export class CreateCycleDialogComponent implements OnInit {
  private instanceId: string;

  public isError: boolean = false;

  public cycleName: string | undefined;

  public cycleDuration: number | undefined;

  public isSpinning: boolean = false;

  public cycleDurations: number[] = CYCLEDURATIONS;

  public cycles: cycle[] = [];

  private allCycles: cycle[] = [];

  public cyclesTVO: CycleTVO[] = [];

  public cycleSource: cycle | undefined;

  private page: number = 1;

  private pageSize: number = 7;

  public isLoading: boolean = true;

  public isOptimUnderConstraint: boolean = false;

  public isMainFromOptimUnderConstraint: boolean = false;

  public alreadyHaveMainOptimUnderConstraintCycle: boolean = false;

  public cycleTVO: CycleTVO | undefined;

  public isNight: boolean = false;

  public exclusions: Exclusion[] = [];

  private profiles: Profile[] = [];

  public allProfiles: Profile[] | undefined;

  private interval: any;

  public progress = 0;

  private iadeProfiles: Profile[] | undefined;

  private anesthProfiles: Profile[] | undefined;

  private seniorProfiles: Profile[] | undefined;

  private juniorProfiles: Profile[] | undefined;

  private internProfiles: Profile[] | undefined;

  private nurseprofiles: Profile[] | undefined;

  public profileListName: string | undefined;

  public profileListOptions: string[] = [];

  public profileListNames: string[] = [];

  public profilesStatus: string[] = ['Titulaire', 'Vacataire'];

  public selectedProfilesStatus: string[] = ['Titulaire', 'Vacataire'];

  public profilesSeniorities: string[] = [''];

  public selectedProfilesSeniorities: string[] = [];

  public profilesSeniority: string | undefined;

  private type: string | undefined;

  private position: string | undefined;

  public isAnesthDisabled: boolean = false;

  public searchValue: string | undefined;

  private isAllSelectedBySeniotity: { [key: string]: boolean } = {};

  public formGroup: FormGroup | undefined;

  public profilesFormElements: any;

  public hospitalNames: HospitalNames;

  public accessOptions: AccessOptions | undefined;

  public gap: string = '10px';

  public allFormationsGroups: FormationsGroups[] = [];

  public isUsingSeniorities: boolean = false;

  public createMainOptim: boolean = false;

  private selectedAllFormation: FormationsGroups = {};

  private profilesSenioritiesObj: { [key: string]: string } = {
    Senior: 'Séniors',
    Junior: 'Juniors',
    Interne: 'Internes',
    Séniors: 'Senior',
    Juniors: 'Junior',
    Internes: 'Interne',
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly profileService: ProfileService,
    private readonly cycleService: CycleService,
    private readonly dialogRef: MatDialogRef<CreateCycleDialogComponent>,
    private readonly errorService: ErrorService,
    private readonly userService: UserService,
    private readonly cycleTVOService: CycleTVOService,
    private readonly toastService: ToastService,
    private readonly nightNeedsListService: NightNeedsListService,
    private readonly exclusionService: ExclusionService,
    private readonly dialog: MatDialog,
    private readonly formBuilder: FormBuilder,
    private readonly formatSeniority: FormatSeniorityPipe,
    private readonly router: Router,
    private destroyRef: DestroyRef,
    private subscriptionManager: SubscriptionManager,
    private instanceIdService: InstanceIdService
  ) {
    this.instanceId = this.instanceIdService.generateId();
    this.subscriptionManager.registerComponent(this.instanceId, this.destroyRef);
    this.accessOptions = this.userService.getAccessOptionsOfPage(this.router.url);
    this.hospitalNames = this.userService.getHospitalNames();
    this.isNight = this.data.isNight;
    this.alreadyHaveMainOptimUnderConstraintCycle = this.data.alreadyHaveMainOptimUnderConstraintCycle;

    if (Array.isArray(this.accessOptions?.seniority) && this.accessOptions.seniority.length) {
      this.profilesSeniorities = this.accessOptions?.seniority.map((s: string) => this.profilesSenioritiesObj[s]);
      if (this.profilesSeniorities.length > 0) {
        this.profilesSeniority = this.profilesSeniorities[0];
      }
    }
  }

  async ngOnInit() {
    this.type = this.data.type;
    this.position = this.data.type;
    this.profilesSeniorities.forEach((seniority: string) => {
      this.isAllSelectedBySeniotity[seniority] = false;
    });

    this.allFormationsGroups = (await this.userService.getAllFormationsGroups()).filter(
      (formationGroups: FormationsGroups) => {
        return formationGroups.typeMode && ['nurse', 'iade', 'anesth'].includes(formationGroups.typeMode);
      }
    );
    this.allFormationsGroups = this.userService.removeOverlappingFormationsFromDefaults(this.allFormationsGroups);

    if (
      Array.isArray(this.accessOptions?.typeOfCycles) &&
      this.accessOptions.typeOfCycles.length > 0 &&
      this.allFormationsGroups.length > 0
    ) {
      this.profileListOptions = this.accessOptions.typeOfCycles.map((typeOfCycle: string) => {
        return (
          this.allFormationsGroups.find(
            (formationGroup: FormationsGroups) => String(formationGroup._id) === String(typeOfCycle)
          )?.displayName ?? ''
        );
      });
    }

    this.profileListName = this.profileListOptions[0];
    this.profileListNames = [this.profileListOptions[0]];

    this.getCycles();
    this.getCyclesTVO();
    if (this.isNight) {
      this.getExclusionService();
    } else {
      await this.getProfiles();
    }
    this.createForm();
    this.initForm();
    this.onProfilesSelectionChange();
  }

  createForm() {
    this.formGroup = this.formBuilder.group({
      profiles: [''],
    });
  }

  initForm() {
    if (Array.isArray(this.profiles)) {
      this.profilesFormElements = [
        { label: 'Tout sélectionner', value: 'all', isChecked: this.profiles.every((el: Profile) => el.checked) },
      ];
      for (const profile of this.profiles) {
        this.profilesFormElements.push({
          label:
            `${this.capitalize(profile?.firstName ?? '')} ${this.capitalize(profile?.lastName ?? '')} - ` +
            (profile?.seniority
              ? this.formatSeniority.transform(profile?.seniority ?? '')
              : (profile?.position ?? '')) +
            `  - ${this.capitalize(profile?.residency ?? '')}`,
          isChecked: profile.checked,
          value: profile._id,
        });
      }
      this.formGroup
        ?.get('profiles')
        ?.setValue(this.profilesFormElements.filter((el: any) => el.isChecked).map((el: any) => el.value));
    }
  }

  onProfilesSelectionChange() {
    if (this.formGroup?.get('profiles')) {
      this.subscriptionManager
        .createRequest(this.formGroup.get('profiles')!.valueChanges, 'profilesSelectionChange', this.instanceId)
        .subscribe({
          next: (val: any) => {
            if (
              this.profilesSeniority &&
              !this.isAllSelectedBySeniotity[this.profilesSeniority] &&
              val.includes('all')
            ) {
              this.isAllSelectedBySeniotity[this.profilesSeniority] = true;
              this.profiles.forEach((profile: Profile) => {
                profile.checked = true;
              });
              this.profilesFormElements.forEach((profile: any) => {
                profile.isChecked = true;
              });
              this.selectAllChange(true, this.profilesSeniority);
              return;
            }

            if (
              this.profilesSeniority &&
              this.isAllSelectedBySeniotity[this.profilesSeniority] &&
              !val.includes('all')
            ) {
              this.isAllSelectedBySeniotity[this.profilesSeniority] = false;
              this.profiles.forEach((profile: Profile) => {
                profile.checked = false;
              });
              this.profilesFormElements.forEach((profile: any) => {
                profile.isChecked = false;
              });
              this.selectAllChange(false, this.profilesSeniority);
              return;
            }

            if (
              this.profilesSeniority &&
              !this.isAllSelectedBySeniotity[this.profilesSeniority] &&
              this.profilesFormElements
                .filter((el: any) => el.value !== 'all')
                .every((profileElement: any) => profileElement.isChecked)
            ) {
              this.isAllSelectedBySeniotity[this.profilesSeniority] = true;
              this.profilesFormElements.find((profileElement: any) => profileElement.value === 'all').isChecked = true;
            } else {
              if (this.profilesSeniority) {
                this.isAllSelectedBySeniotity[this.profilesSeniority] = false;
                this.profilesFormElements.find((profileElement: any) => profileElement.value === 'all').isChecked =
                  false;
              }
            }

            this.profiles.forEach((profile: Profile) => {
              profile.checked = val.includes(profile._id);
            });

            if (this.profilesSeniority) {
              this.onProfileSelectionChange(this.profiles, this.profilesSeniority);
            }
          },

          error: (error: any) => {
            this.errorService.handleError(error);
          },
        });
    }
  }

  getExclusionService() {
    this.subscriptionManager
      .createRequest(this.exclusionService.getAllExclusions(), 'getAllExclusions', this.instanceId)
      .subscribe({
        next: async (res: any) => {
          this.exclusions = res;
          await this.getProfiles();
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  async getProfiles() {
    const formations = JSON.stringify(
      (await this.userService.getAccessOptionsPositionsByPositions(this.accessOptions?.typeOfCycles, true)).map(
        (formation: Formation) => formation._id
      )
    );

    this.subscriptionManager
      .createRequest(
        this.profileService.getProfilesByPosition(
          'All',
          this.page,
          this.pageSize,
          '',
          false,
          true,
          true,
          undefined,
          this.isNight,
          false,
          false,
          undefined,
          formations
        ),
        'getProfilesByPosition',
        this.instanceId
      )
      .subscribe({
        next: (res: any) => {
          this.allProfiles = res.docs;
          this.anesthProfiles = [...(this.allProfiles?.filter((p: Profile) => p.position === ANESTHETIST) ?? [])];
          this.seniorProfiles = [...this.anesthProfiles.filter((p: Profile) => p.seniority === 'Senior')];
          this.juniorProfiles = [...this.anesthProfiles.filter((p: Profile) => p.seniority === 'Junior')];
          this.internProfiles = [...this.anesthProfiles.filter((p: Profile) => p.seniority === 'Interne')];
          this.iadeProfiles = [
            ...(this.allProfiles?.filter((p: Profile) => p.position?.toLowerCase() === 'iade') ?? []),
          ];
          this.nurseprofiles = [
            ...(this.allProfiles?.filter((p: Profile) => !NOT_NURSES.includes(p.position ?? '')) ?? []),
          ];
          this.getProfileListType(this.profileListOptions[0]);
          if (this.isNight) {
            this.setNightChecked();
          }
          this.isLoading = false;
          if (
            this.profilesSeniority &&
            this.profiles.length === this.profiles.filter((x: Profile) => x.checked).length
          ) {
            this.isAllSelectedBySeniotity[this.profilesSeniority] = true;
          }
        },
        error: (error: any) => {
          this.isLoading = false;
          this.errorService.handleError(error);
        },
      });
  }

  async setNightChecked() {
    if (this.type === ANESTHETIST) {
      const formationsGroupAnesth = (await this.userService.getAllFormationsGroups()).find(
        (formationsGroup: FormationsGroups) => formationsGroup.name === 'ANESTHESISTES'
      );

      const formationsGroupIades = (await this.userService.getAllFormationsGroups()).find(
        (formationsGroup: FormationsGroups) => formationsGroup.name === 'IADES'
      );

      this.seniorProfiles = this.seniorProfiles?.filter(
        (profile: Profile) =>
          !this.exclusions.find(
            (exclusion: Exclusion) =>
              (formationsGroupAnesth &&
                exclusion.formationsGroup === formationsGroupAnesth._id &&
                exclusion.seniority?.[0] === 'Senior') ||
              (String(exclusion.profile) === String(profile._id) && !exclusion.reason)
          )
      );

      this.juniorProfiles = this.juniorProfiles?.filter(
        (profile: Profile) =>
          !this.exclusions.find(
            (exclusion: Exclusion) =>
              (formationsGroupAnesth &&
                exclusion.formationsGroup === formationsGroupAnesth._id &&
                exclusion.seniority?.[0] === 'Junior') ||
              (String(exclusion.profile) === String(profile._id) && !exclusion.reason)
          )
      );

      this.internProfiles = this.internProfiles?.filter(
        (profile: Profile) =>
          !this.exclusions.find(
            (exclusion: Exclusion) =>
              (formationsGroupAnesth &&
                exclusion.formationsGroup === formationsGroupAnesth._id &&
                exclusion.seniority?.[0] === 'Intern') ||
              (String(exclusion.profile) === String(profile._id) && !exclusion.reason)
          )
      );

      this.iadeProfiles = this.iadeProfiles?.filter(
        (profile: Profile) =>
          !this.exclusions.find(
            (exclusion: Exclusion) =>
              exclusion.formationsGroup === formationsGroupIades?._id ||
              (String(exclusion.profile) === String(profile._id) && !exclusion.reason)
          )
      );
    } else {
      const formationsGroupNurses = (await this.userService.getAllFormationsGroups()).find(
        (formationsGroup: FormationsGroups) => formationsGroup.name === 'NURSES'
      );

      this.profiles = this.profiles?.filter(
        (profile: Profile) =>
          !this.exclusions.find(
            (exclusion: Exclusion) =>
              exclusion.formationsGroup === formationsGroupNurses?._id ||
              (String(exclusion.profile) === String(profile._id) && !exclusion.reason)
          )
      );
      this.initForm();
    }
  }

  createCycle(template: any): void {
    if (!this.allProfiles) {
      return;
    }
    const selectedProfils = this.getSelectedIDS(this.allProfiles);

    if (this.isFormValid()) {
      this.isSpinning = true;

      const cycle: any = {
        weeks: this.isOptimUnderConstraint ? this.cycleTVO?.weeks : this.cycleDuration,
        name: this.cycleName,
        profiles: selectedProfils,
        nightCycle: this.isNight && this.cycleTVO ? this.cycleTVO._id : undefined,
        cycleTVO: this.isOptimUnderConstraint && !this.isNight ? this.cycleTVO?._id : undefined,
        fromOptimUnderConstraint: this.isOptimUnderConstraint,
        isMainFromOptimUnderConstraint: this.isMainFromOptimUnderConstraint,
        position: this.selectedAllFormation?._id,
        isGarde: this.isNight,
        seniorities:
          this.selectedProfilesSeniorities.length > 0
            ? this.selectedProfilesSeniorities.map((s: string) => this.profilesSenioritiesObj[s])
            : null,
      };

      let copyFrom: string = '';
      if (!this.isOptimUnderConstraint && this.cycleSource?._id && this.cycleSource.name !== 'Vide') {
        copyFrom = this.cycleSource._id;
      }

      this.subscriptionManager
        .createRequest(this.cycleService.createCycle(cycle, copyFrom), 'createCycle', this.instanceId)
        .subscribe({
          next: (res: any) => {
            this.isSpinning = false;
            res.cycle.profiles = this.allProfiles?.filter((el: Profile) => el.checked);
            if (res.cycle.fromOptimUnderConstraint) {
              this.progress = 0;

              const dialogRef = this.dialog.open(template, {
                width: '240px',
                disableClose: true,
              });
              this.interval = setInterval(() => {
                if (this.progress < 96) {
                  this.progress += 1.6667;
                } else {
                  this.progress = 99;
                  clearInterval(this.interval);
                }
              }, 1000);
              this.subscriptionManager
                .createRequest(
                  this.cycleService.updateOptimCycle(res.cycle._id, this.isNight),
                  'updateOptimCycle',
                  this.instanceId
                )
                .subscribe({
                  next: () => {
                    clearInterval(this.interval);
                    dialogRef.close();
                    this.dialogRef.close({ result: true });
                    this.toastService.infoToast(this.hospitalNames.cyclesName + ' mis à jour.');
                  },
                  error: (error: any) => {
                    this.errorService.handleError(error);
                    clearInterval(this.interval);
                    dialogRef.close();
                    this.dialogRef.close({ result: false });
                  },
                });
            } else {
              this.dialogRef.close({ result: true });
              this.toastService.infoToast(this.hospitalNames.cyclesName + ' créé.');
            }
          },
          error: (error: any) => this.errorService.handleError(error),
        });
    }
  }

  getSelectedIDS(profiles: any[]) {
    const selectProfiles = profiles.filter((el: Profile) => el.checked);
    return selectProfiles.map((el: Profile) => el._id);
  }

  isFormValid(): boolean {
    if (this.isOptimUnderConstraint && this.cycleName) {
      return true;
    }
    return !!(this.cycleName && this.cycleDuration);
  }

  async getCycles() {
    const positions =
      Array.isArray(this.accessOptions?.typeOfCycles) && this.accessOptions.typeOfCycles.length > 0
        ? this.accessOptions.typeOfCycles
        : [];

    this.subscriptionManager
      .createRequest(this.cycleService.getCycles(positions), 'getCycles', this.instanceId)
      .subscribe({
        next: (res: any) => {
          const emptyCycle = {
            name: 'Vide',
          };
          this.cycles = [emptyCycle, ...res];
          this.allCycles = res;
          this.createMainOptim = this.canCreateMainOptim();
        },

        error: (error: any) => {
          this.errorService.handleError(error);
        },
      });
  }

  canCreateMainOptim(): boolean {
    if (
      this.position === 'Infirmiere' &&
      this.allCycles.find((cycle: cycle) => {
        return (
          cycle.fromOptimUnderConstraint &&
          cycle.isMainFromOptimUnderConstraint &&
          this.allFormationsGroups.find(
            (formationsGroup: FormationsGroups) =>
              formationsGroup.typeMode === 'nurse' && String(formationsGroup._id) === String(cycle.position)
          )
        );
      })
    ) {
      return false;
    } else if (
      this.position === 'Anesthésiste' &&
      this.allCycles.find(
        (cycle: cycle) =>
          cycle.fromOptimUnderConstraint &&
          cycle.isMainFromOptimUnderConstraint &&
          this.allFormationsGroups?.find(
            (formationsGroup: FormationsGroups) =>
              formationsGroup.typeMode === 'anesth' && String(formationsGroup._id) === String(cycle.position)
          )
      )
    ) {
      return false;
    } else if (
      this.position === 'Iade' &&
      this.allCycles.find(
        (cycle: cycle) =>
          cycle.fromOptimUnderConstraint &&
          cycle.isMainFromOptimUnderConstraint &&
          this.allFormationsGroups?.find(
            (formationsGroup: FormationsGroups) =>
              formationsGroup.typeMode === 'iade' && String(formationsGroup._id) === String(cycle.position)
          )
      )
    ) {
      return false;
    }

    return true;
  }

  async getCyclesTVO() {
    if (!this.isNight) {
      this.subscriptionManager
        .createRequest(this.cycleTVOService.getCyclesTVO(), 'getCyclesTVO', this.instanceId)
        .subscribe({
          next: (res: any) => {
            this.cyclesTVO = res;
            this.cycleTVO = this.cyclesTVO.find((cycle: any) => cycle.main === true) || this.cyclesTVO[0];
          },

          error: (error: any) => {
            this.errorService.handleError(error);
          },
        });
    } else {
      this.subscriptionManager
        .createRequest(
          this.nightNeedsListService.getNightNeedsLists(this.accessOptions?.typeOfCycles?.join(',') ?? ''),
          'getNightNeedsLists',
          this.instanceId
        )
        .subscribe({
          next: (res: any) => {
            this.cyclesTVO = res;
            this.cycleTVO = this.cyclesTVO.find((cycle: any) => cycle.main === true) || this.cyclesTVO[0];
          },

          error: (error: any) => {
            this.errorService.handleError(error);
          },
        });
    }
  }

  close(): void {
    this.dialogRef.close();
  }

  updateProfiles() {
    if (this.cycleSource?.name === 'Vide') {
      return;
    }
    this.allProfiles?.forEach((el: Profile) => (el.checked = false));
    if (this.cycleSource?.profiles && this.cycleSource.position) {
      this.setProfilesAsSelected(this.cycleSource.profiles, this.cycleSource.position);
    } else {
      if (this.type === ANESTHETIST) {
        this.getProfileListType(null);
      } else {
        if (this.position === 'Infirmiere') {
          this.profiles = this.allProfiles?.filter((x: Profile) => NURSE_TYPES.includes(x.position ?? '')) ?? [];
        } else {
          if (this.position === 'Iade') {
            this.profiles = this.allProfiles?.filter((x: Profile) => x.position === 'Iade') ?? [];
          } else {
            this.profiles = this.allProfiles?.filter((x: Profile) => x.position === this.position) ?? [];
            switch (this.profilesSeniority) {
              case 'Séniors':
                this.profiles = this.profiles?.filter((x: Profile) => x.seniority === 'Senior');
                break;
              case 'Juniors':
                this.profiles = this.profiles?.filter((x: Profile) => x.seniority === 'Junior');
                break;
              case 'Internes':
                this.profiles = this.profiles?.filter((x: Profile) => x.seniority === 'Interne');
                break;
            }
          }
        }
      }
    }
    this.initForm();
  }

  setProfilesAsSelected(profiles: any[], position: string) {
    this.allProfiles?.forEach((el: Profile) => {
      const index = profiles.findIndex((selProf: Profile) => selProf._id == el._id);
      if (index != -1) {
        el.checked = true;
        this.isAnesthDisabled = true;
      }
    });
    const formationGroups = this.allFormationsGroups?.find(
      (formationsGroup: FormationsGroups) => String(formationsGroup._id) === String(position)
    );

    this.isUsingSeniorities = formationGroups?.isUsingSeniorities ?? false;
    this.profileListName = formationGroups?.displayName;
    this.position =
      formationGroups?.typeMode === 'nurse'
        ? 'Infirmiere'
        : formationGroups?.typeMode === 'anesth'
          ? 'Anesthésiste'
          : formationGroups?.typeMode === 'iade'
            ? 'Iade'
            : '';
    this.profiles?.forEach((el: Profile) => {
      const index = profiles.findIndex((selProf: Profile) => selProf._id == el._id);
      if (index != -1) {
        el.checked = true;
      }
    });

    this.profileListNames.length = 0;
    this.selectedProfilesSeniorities.length = 0;

    if (this.profileListName) {
      this.profileListNames.push(this.profileListName);
    }

    if (this.position === 'Infirmiere') {
      this.profiles = [...(this.nurseprofiles ?? [])];
    }

    if (this.position === 'Anesthésiste') {
      if (Array.isArray(this.cycleSource?.seniorities) && this.cycleSource.seniorities.length > 0) {
        this.selectedProfilesSeniorities =
          this.cycleSource?.seniorities.map((s: string) => this.profilesSenioritiesObj[s]) ?? [];
      } else {
        this.selectedProfilesSeniorities.push('Séniors');
      }
      this.profiles = [];
      this.selectedProfilesSeniorities.forEach((s: string) => {
        if (s === 'Séniors') {
          this.profiles.push(...(this.seniorProfiles ?? []));
        }
        if (s === 'Juniors') {
          this.profiles.push(...(this.juniorProfiles ?? []));
        }
        if (s === 'Internes') {
          this.profiles.push(...(this.internProfiles ?? []));
        }
      });
    }

    if (this.position === 'Iade') {
      this.profiles = [...(this.iadeProfiles ?? [])];
    }

    //filter by status
    if (this.selectedProfilesStatus.length < 2) {
      this.profiles = this.profiles.filter((item: any) => this.selectedProfilesStatus.includes(item.residency));
    }
    this.initForm();
  }

  doFilter(value: string) {
    this.getProfileListType(null);

    this.profiles = this.profiles.filter((profile: Profile) => {
      const re = new RegExp(value, 'gi');
      return profile.firstName?.match(re) != null || profile.lastName?.match(re) != null;
    });
    if (this.profilesSeniority) {
      this.isAllSelectedBySeniotity[this.profilesSeniority] = this.profiles.every(
        (profile: Profile) => profile.checked
      );
    }
    this.initForm();
  }

  selectAllChange(checked: boolean, seniority: string) {
    const isChecked = checked;
    this.isAllSelectedBySeniotity[seniority] = checked;
    this.profiles.forEach((profile: Profile) => {
      profile.checked = isChecked;
    });
    const sum_checked = Object.values(this.isAllSelectedBySeniotity).filter((value: boolean) => value === true).length;
    this.isAnesthDisabled = sum_checked !== 0;
  }

  onProfileSelectionChange(profiles: any, seniority: string): void {
    if (profiles.some((profile: Profile) => profile.checked)) {
      this.isAnesthDisabled = true;
    }
    if (this.position === 'Anesthésiste') {
      if (
        this.allProfiles?.filter((x: Profile) => x.checked && x.position === 'Anesthésiste' && x.seniority).length === 0
      ) {
        this.isAnesthDisabled = false;
      }
    } else if (this.allProfiles?.filter((x: Profile) => x.checked).length === 0) {
      this.isAnesthDisabled = false;
    }
    this.isAllSelectedBySeniotity[seniority] =
      this.profiles.length === this.profiles.filter((x: Profile) => x.checked).length;
  }

  isProfileSelected(profileValue: string): boolean {
    const selectedProfiles = this.formGroup?.get('profiles')?.value || [];
    if (profileValue === 'all') {
      const allProfileValues = this.profilesFormElements
        .filter((profile: any) => profile.value !== 'all')
        .map((profile: any) => profile.value);

      return allProfileValues.every((value: any) => selectedProfiles.includes(value));
    }
    return selectedProfiles.includes(profileValue);
  }

  onProfileChange(event: any, profileValue: string) {
    const isChecked = event.checked;
    const currentValues = this.formGroup?.get('profiles')?.value || [];

    let newValues;
    if (profileValue === 'all') {
      if (isChecked) {
        newValues = this.profilesFormElements
          .filter((profile: any) => profile.value !== 'all')
          .map((profile: any) => profile.value);
      } else {
        newValues = [];
      }
    } else {
      if (isChecked) {
        newValues = [...currentValues, profileValue];
      } else {
        newValues = currentValues.filter((value: string) => value !== profileValue);
      }
    }

    this.formGroup?.get('profiles')?.setValue(newValues);
  }

  capitalize(s: string): string {
    const text = s.toLowerCase();
    return text.charAt(0).toUpperCase() + text.slice(1);
  }

  /**
   * Update selected formations and seniority
   * variable profileListName handles formations that are checked
   * variable profileListNamesTmp handles formations and seniorities selected to display profiles
   * @param event formation or seniority selected/unselected
   */
  async getProfileListType(event: string | null) {
    // event : 'Anesthésiste' | 'Séniors' | 'Juniors' | 'Internes' | 'IADE' | null
    let profileListNamesTmp: string[] = [];
    if (event) {
      if (this.profileListOptions.includes(event)) {
        const formationGroups = this.allFormationsGroups.find(
          (formationGroup: FormationsGroups) => formationGroup.displayName === event
        );
        //Formation
        this.profileListName = event;

        this.isUsingSeniorities = formationGroups?.isUsingSeniorities ?? false;
        if (
          this.isUsingSeniorities &&
          Array.isArray(this.accessOptions?.seniority) &&
          this.accessOptions?.seniority.length > 0
        ) {
          this.selectedProfilesSeniorities.push(this.profilesSenioritiesObj[this.accessOptions?.seniority?.[0]]);
          this.profileListNames.push(this.profilesSenioritiesObj[this.accessOptions?.seniority?.[0]]);
        }

        if (!this.profileListNames) {
          this.profileListNames = [];
        }

        //Does formation already selected?
        const indexTmp = this.profileListNames.indexOf(event);

        if (indexTmp > -1) {
          this.profileListNames.splice(indexTmp, 1);
          if (this.isUsingSeniorities) {
            this.profileListNames = this.profileListNames.filter((item: string) => item !== 'Séniors');
            this.selectedProfilesSeniorities.length = 0;
          }
        } else {
          this.profileListNames.push(event);
        }
        this.selectedAllFormation =
          this.allFormationsGroups.find((fGroup: FormationsGroups) =>
            event ? fGroup.displayName === event : fGroup.displayName === profileListNamesTmp?.[0]
          ) || {};
      } else if (['Séniors', 'Juniors', 'Internes'].includes(event)) {
        //Seniority
        //Does formation already selected?
        const indexSeniorityTmp = this.selectedProfilesSeniorities.indexOf(event);

        if (indexSeniorityTmp > -1) {
          this.selectedProfilesSeniorities?.splice(indexSeniorityTmp, 1);
        } else {
          this.selectedProfilesSeniorities?.push(event);
        }

        this.profilesSeniority = event;
      } else {
        //Status
        const index = this.selectedProfilesStatus?.indexOf(event);

        if (index > -1) {
          this.selectedProfilesStatus?.splice(index, 1);
        } else {
          this.selectedProfilesStatus?.push(event);
        }
      }
    }

    // deselect Anesth if no seniority selected
    if (this.selectedProfilesSeniorities?.length === 0) {
      this.isUsingSeniorities = false;
      this.profileListNames = this.profileListNames.filter((item: string) => {
        const formationGroups = this.allFormationsGroups.find(
          (formationGroup: FormationsGroups) => formationGroup.displayName === item
        );
        return !formationGroups?.isUsingSeniorities;
      });
    }

    // create list of types of profiles to display
    profileListNamesTmp = [...(this.profileListNames || [])];
    const anesthSelected = this.profileListNames.some((profileName: string) => {
      const formationGroups = this.allFormationsGroups.find(
        (formationGroup: FormationsGroups) => formationGroup.displayName === profileName
      );
      return formationGroups?.isUsingSeniorities;
    });
    if (anesthSelected) {
      profileListNamesTmp.push(...this.selectedProfilesSeniorities);
    }

    // delete seniorities from formations names array
    this.profileListNames = this.profileListNames.filter((item: string) => this.profileListOptions.includes(item));

    // delete 'Anesthésiste' from array
    profileListNamesTmp = profileListNamesTmp.filter((profileName: string) => {
      const formationGroups = this.allFormationsGroups.find(
        (formationGroup: FormationsGroups) => formationGroup.displayName === profileName
      );
      return !formationGroups?.isUsingSeniorities;
    });

    this.profiles = [];

    profileListNamesTmp?.forEach((name: string) => {
      const typeMode =
        this.allFormationsGroups.find((formationGroup: FormationsGroups) => formationGroup.displayName === name)
          ?.typeMode ?? name;
      switch (typeMode) {
        case 'nurse':
          this.profiles = [...this.profiles, ...(this.nurseprofiles ?? [])];
          this.position = 'Infirmiere';
          break;
        case 'anesth':
          this.profiles = [...this.profiles, ...(this.anesthProfiles ?? [])];
          this.position = 'Anesthésiste';
          break;
        case 'Séniors':
          this.profiles = [...this.profiles, ...(this.seniorProfiles ?? [])];
          this.position = 'Anesthésiste';
          break;
        case 'Juniors':
          this.profiles = [...this.profiles, ...(this.juniorProfiles ?? [])];
          this.position = 'Anesthésiste';
          break;
        case 'Internes':
          this.profiles = [...this.profiles, ...(this.internProfiles ?? [])];
          this.position = 'Anesthésiste';
          break;
        case 'iade':
          this.profiles = [...this.profiles, ...(this.iadeProfiles ?? [])];
          this.position = 'Iade';
          break;
        default:
      }
    });
    if (this.selectedAllFormation) {
      const formations = (await this.userService.getFormationsOfFormationsGroup(this.selectedAllFormation, true)).map(
        (formation: any) => formation.name
      );
      this.profiles = this.profiles?.filter((profile: Profile) => formations.includes(profile.position));
    }

    //filter by status
    if (this.selectedProfilesStatus.length < 2) {
      this.profiles = this.profiles.filter((item: any) => this.selectedProfilesStatus.includes(item.residency));
    }

    //uncheck all profiles
    if (['Séniors', 'Juniors', 'Internes'].includes(event ?? '')) {
      this.allProfiles?.forEach((profile: Profile) => {
        profile.checked = false;
      });
    }

    this.initForm();
  }

  isOptionDisabled(option: string): boolean {
    if (!this.profileListNames.length) {
      return false;
    }
    const isSelected = this.profileListNames.includes(option);
    return !isSelected;
  }
}
